import http from './../http.interceptor.js';

export function luckyTurntable(params) {
  return http.post('/v3.activity/luckyTurntable', {
    isLOgin: true,
    ...params
  });
}

export function startTurntable(params) {
  return http.post('/v3.activity/startTurntable', {
    isLOgin: true,
    ...params
  });
}

export function lossSubsidy(params) {
  return http.post('/v3.activity/lossSubsidy', {
    isLOgin: true,
    ...params
  });
}

export function lossSubsidyWeek(params) {
  return http.post('/v3.activity/lossSubsidyWeek', {
    isLOgin: true,
    ...params
  });
}

export function claimActivityRewards(params) {
  return http.post('/v3.activity/claimActivityRewards', {
    isLOgin: true,
    ...params
  });
}

export function dailySignIn(params) {
  return http.post('/v3.activity/dailySignIn', {
    isLOgin: true,
    ...params
  });
}

export function doDailySign(params) {
  return http.post('/v3.activity/doDailySign', {
    isLOgin: true,
    ...params
  });
}

export function firstRecharge(params) {
  return http.post('/v3.activity/firstRecharge', {
    isLOgin: true,
    ...params
  });
}

export function betRebate(params) {
  return http.post('/v3.activity/betRebate', {
    isLOgin: true,
    ...params
  });
}

export function rewards(params) {
  return http.post('/v3.activity/rewards', {
    isLOgin: true,
    ...params
  });
}

export function platformRebate(params) {
  return http.post('/v3.activity/platformRebate', {
    isLOgin: true,
    ...params
  });
}

export function useRedemptionCode(params) {
  return http.post('/v3.activity/useRedemptionCode', {
    ...params
  });
}
